<template>

  <div class="home" >

    <!-- pc -->
    <div id="home-area" class="compel-fullscreen">

      <!--tabletでのロゴ-->
      <div class="ms-logo-position d-none d-sm-flex d-md-none">
        <div>
          <img v-lazy="require('../../assets/img/logo_header.png')" height="90">
          <!--<img v-else v-lazy="require('../../assets/img/mock/top/' + vegalta + '/logo_top.webp')" width="91" height="84">-->
        </div>
        <div class="ms-logo-obi"><span class="font-bold font-large-m">{{globalSchoolNameEn}}</span><span class="font-large-s pl-2">{{globalSchoolTypeEn}}</span><div class="ms-logo-obi-tr"></div></div>
      </div>
      <!--tabletでのロゴここまで-->

      <!--spでのロゴ-->
      <div class="sp-logo-position d-flex d-sm-none">
        <div>
          <img v-lazy="require('../../assets/img/logo_header.png')" height="60">
          <!--<img v-else :src="require('../../assets/img/mock/top/' + vegalta + '/logo_top.webp')" width="58" height="53">-->
        </div>
        <div class="sp-logo-obi "><span class="font-bold font-medium-xl">{{globalSchoolNameEn}}</span><span class="font-medium-s pl-1">{{globalSchoolTypeEn}}</span><div class="sp-logo-obi-tr"></div></div>
      </div>
      <!--spでのロゴここまで-->

      <!--スライドショー-->
      <div class="slider-inner pb-5" :key="i" v-for="(slide,i) in slides">
        <transition name="fade" v-if="current_slide == i">
          <img class="slide-img width-100-per" v-lazy="slide.img" :key="slide.img">
          <!--<img v-else class="slide-img" v-lazy="slidesWebp[i].img" :key="slidesWebp[i].img" width="100%" height="auto">-->
        </transition>
      </div>

      <!--画面の枠-pc-->
      <div class="decoration-inner d-none d-sm-flex">
        <img v-lazy="require('../../assets/img/top/decoration_image.png')" height="auto" class="decoration-img width-100-per">
      </div>
      <!--画面の枠-sp-->
      <div class="decoration-inner d-flex d-sm-none">
        <img v-lazy="require('../../assets/img/top/decoration_image_sp.png')" height="auto" class="decoration-img width-100-per" >
        <!--<img v-else :src="require('../../assets/img/mock/top/' + vegalta + '/decoration_image_sp.webp')" width="100%" height="auto" class="decoration-img" >-->
      </div>

      <div class="bottom-content">
        <!--PCでのロゴ-->
        <div class="mb-8 center-align font-color-white d-none d-md-flex colum-item ml-10" style="white:36%;margin-top:auto;">
          <div>
            <img v-lazy="require('../../assets/img/top/logo_top.png')" width="132">
            <!--<img v-else :src="require('../../assets/img/mock/top/' + vegalta + '/logo_top.webp')" width="132" height="auto">-->
          </div>
          <div class="pl-3" v-if="topTeamName">
            <div class="line-height-m font-bold team-name-pc font-color-top-school-name-pc">{{globalSchoolNameEn}}</div>
            <div class="font-large-sm font-color-top-school-name-pc">{{globalSchoolTypeEn}}</div>
          </div>
          <div class="pl-3" v-else>
            <img v-if="!topTeamName" :src="'../../assets/img/top/logo_top_text.png'" width="380" @error="topTeamName = true">
          </div>
        </div>
        <!--pc-msのボタン-->
        <div style="width:100%; position: relative;" class="center-margin pt-5">
          <div :class="{'position-nonotice-y-top': !$store.state.eventUseFlag && !impotant_notice && subLinkData.length === 0}">
            <linkCard class="link-outer d-none d-sm-flex center-margin"></linkCard>
            <div v-if="impotant_notice" class="important-notice center-margin px-4 mb-4">
              <v-row class="pa-0 ma-0">
                <v-col cols="12" sm="3" class="pa-0 ma-0 important-notice-title center-margin">
                  <div class="important-notice-title-inner">
                    <v-icon size="20" color="#fff" class="pr-1">mdi-alert-octagon</v-icon>
                    <span>重要なお知らせ</span>
                  </div>
                </v-col>
                <v-col cols="12" sm="9" class="pa-0 ma-0 important-notice-text">
                  <div class="px-2">{{impotant_notice}}</div>
                </v-col>
              </v-row>
            </div>

            <!--subLink-->
            <div v-if="subLinkData.length > 0" class="pt-2 pb-4">
              <subLinkCard class="link-outer d-none d-sm-flex center-margin"></subLinkCard>
            </div>
          </div>
          <!--イベント遷移用ボタン-->
          <div v-if="$store.state.eventUseFlag" class="width-90-per ma-auto d-none d-sm-block pb-3">
            <v-card tile elevation="3" height="60px" class="event-link-card mx-4" color="warning" @click="$router.push('/event')">
              <div class="event-link-card-inner">
                <div class="margin-auto">
                  <div class="event-card-text-area">
                    <div class="card-title font-bold font-large-xs line-height-m">開催イベント一覧</div>
                  </div>
                  <v-icon size="18px" color="white" style="margin:8px">mdi-arrow-right-drop-circle</v-icon>
                </div>
              </div>
            </v-card>
          </div>

          <!--subLink-->
          <div v-if="subLinkData.length > 0" class="pt-6">
            <subLinkCard class="link-outer d-none d-sm-flex center-margin"></subLinkCard>
          </div>
        </div>

      </div>
    </div>

    <!--spのボタン-->
    <div class="d-flex d-sm-none background-top-btn-back-sp">
      <linkCard class="link-sp-position"></linkCard>
    </div>

    <!--イベント遷移用ボタン-->
    <div v-if="$store.state.eventUseFlag" class="d-block d-sm-none pb-8 background-top-btn-back-sp">
      <v-card tile elevation="3" height="60px" class="event-link-card mx-4" color="warning" @click="$router.push('/event')">
        <div class="event-link-card-inner">
          <div class="margin-auto">
            <div class="event-card-text-area">
              <div class="card-title font-bold font-large-xs line-height-m">開催イベント一覧</div>
            </div>
            <v-icon size="18px" color="white" style="margin:8px">mdi-arrow-right-drop-circle</v-icon>
          </div>
        </div>
      </v-card>
    </div>

    <div v-if="subLinkData.length > 0" class="pt-7 d-flex d-sm-none background-top-btn-back-sp">
      <subLinkCard class="link-sp-position width-100"></subLinkCard>
    </div>

    <v-dialog scrollable v-model="ImportantNoticeModal" width="680" persistent>
      <importantNotice @close="ImportantNoticeModal = false"></importantNotice>
    </v-dialog>

    <!--HOME専用のエラーメッセージ-->
    <v-dialog max-width="680" persistent v-model="homeErrorDialog">
      <v-card id="home-error-dialog">
        <v-card-text>
          <div class="font-large-s font-color-error pt-9 font-bold">
            {{errorMessage.title}}
          </div>
          <div class="pt-4 font-bold">
            {{errorMessage.value}}
          </div>
        </v-card-text>
        <v-card-actions class="modal-footer pa-0">
          <div class="width-100 center-align pb-5 pt-3">
            <v-btn id="home-error-dialog-ok-btn" @click="homeErrorDialog = false" width="128px" variant="flat" color="primary" class="font-bold font-color-primary-btn-text">OK</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import { Storage } from 'aws-amplify'
// import isWebpSupported from '@/js/isWebpSupported'
import linkCard from '@/components/common/LinkCard.vue'
import subLinkCard from '@/components/common/SubLinkCard.vue'
import importantNotice from '@/components/modal/ImportantNotice.vue'

export default {
  name: 'home',
  data: function () {
    return {
      vegalta: 'vegalta',
      slideTime: null,
      impotant_notice: '',
      ImportantNoticeModal: false,
      current_slide: 0,
      topTeamName: false,
      slides: [],
      errorMessage: {
        title: '',
        value: ''
      },
      homeErrorDialog: false
      // slidesWebp: [
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_1.webp'
      //   },
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_2.webp'
      //   },
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_3.webp'
      //   },
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_4.webp'
      //   },
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_5.webp'
      //   },
      //   {
      //     img: 'https://s3-ap-northeast-1.amazonaws.com/suku2.io/img/top_image_6.webp'
      //   }
      // ]
    }
  },
  components: {
    linkCard,
    subLinkCard,
    importantNotice
  },
  methods: {
    init: function () {
      const self = this
      this.slides = []
      Storage.list('img/top/').then(async function (response) {
        await Promise.all(response.filter(v => v.size).map(async function (v, i) {
          await Storage.get(v.key).then(async function (url) {
            await self.slides.push({
              img: url
            })
            return url
          })
          return v
        }).sort((a, b) => parseInt(a.name) < parseInt(b.name) ? 1 : -1))
      })
    },
    time: function () {
      this.current_slide = this.current_slide < this.slides.length - 1 ? this.current_slide + 1 : 0
    }
  },
  mounted: function () {
    const self = this
    this.$router.afterEach(() => {
      window.scrollTo(0, 0)
    })
    this.init()
    this.getInformation().then(response => {
      self.impotant_notice = response.importantNotice
    })
    this.slideTime = setInterval(this.time, 4000)

    if (window.localStorage.getItem('jleagueLoginError')) {
      this.errorMessage.title = 'ログインに失敗しました。'
      switch (window.localStorage.getItem('jleagueLoginError')) {
        case 'Invalid email address format. ': {
          this.errorMessage.value = 'メールアドレスの形式が不正です。ドットが連続するもの、@の直前にドットがあるものなど、RFC違反アドレスは利用できません。別のメールアドレスに変更の上ログインしてください。'
          break
        }
        default: {
          this.errorMessage.value = 'エラーコード：' + window.localStorage.getItem('jleagueLoginError')
          break
        }
      }
      this.homeErrorDialog = true
      window.localStorage.setItem('jleagueLoginError', '')
      window.localStorage.setItem('myPortalAutoLogout', '')
    } else if (window.localStorage.getItem('myPortalAutoLogout')) {
      window.localStorage.setItem('myPortalAutoLogout', '')
      this.errorMessage.title = 'このアカウントには入会情報がありません。'
      this.errorMessage.value = 'このアカウントには入会情報が存在しないため、マイページをご利用いただけません。メールアドレスまたはIDを確認の上、再度「マイページ」からログインしてください。新規入会手続きの方は、「' + this.linkData[0].title + '」に進んでください。'
      this.homeErrorDialog = true
    }
  },
  // computed: {
  //   format () {
  //     return isWebpSupported ? 0 : 1
  //   }
  // },
  destroyed: function () {
    clearInterval(this.slideTime)
  }
}
</script>

<style scoped>

  .compel-fullscreen{
    width: 100vw;
    height: calc(100vh - 56px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
  }

  .team-name-pc{
    font-size: 2.8vw;
    white-space: nowrap;
  }

  .decoration-inner{
    position: absolute;
    width: 100vw;
    height:  calc(100vh - 56px);
    z-index: -1;
  }
  .decoration-img {
    width: 100vw;
    height:  calc(100vh - 56px);
  }

  .slider-inner{
    position: absolute;
    width: 100vw;
    height:  calc(100vh - 56px);
    z-index: -2;
  }
  .slide-img {
    width: 100vw;
    height:  calc(100vh - 56px);
    object-fit: cover;
  }

  .event-link-card {
    height: 100%;
    overflow: hidden;
  }

  .event-link-card-inner{
    display: flex;
    height: 100%;
    position: relative;
  }

  .event-card-text-area {
    display: inline-block;
    vertical-align: middle;
    color: white;
  }

  /*sp*/
  @media screen and (max-width:600px) {
    .slider-inner{
      position: absolute;
      width: 100vw;
      height:  calc(80vh - 56px);
      z-index: -2;
    }
    .slide-img {
      width: 100vw;
      height:  calc(80vh - 56px);
      object-fit: cover;
    }
    .decoration-inner{
      position: absolute;
      width: 100vw;
      height:  calc(80vh - 56px);
      z-index: -1;
    }
    .decoration-img {
      width: 100vw;
      height:  calc(80vh - 56px);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }
    .compel-fullscreen{
      width: 100vw;
      height: calc(80vh - 56px);
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      overflow: hidden;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 1s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  .bottom-content {
    display: flex;
    justify-content: space-evenly;
    position: absolute;
    bottom: 0;
    width: 100vw;
  }
  .link-outer{
    display: flex;
    width: 90%;
    justify-content: inherit;
    align-items: center;
  }
  .inner{
    position: absolute;
    top: 50%;
    width:100%;
    -webkit-transform : translateY(-50%);
    transform : translateY(-50%);
  }
  .position-nonotice-y-top{
    position: relative;
    top:40%;
  }
  /*tablet*/
  @media screen and (min-width:600px) and (max-width:960px) {
    .link-outer{
      width: 90%;
      /*margin-bottom: 32px;*/
    }
    .position-nonotice-y-top{
      top:-50px !important;
    }
    .inner{
      top:-85px;
    }
  }
  .ms-logo-position{
    position:absolute;
    left: 60px;
    top: 10px;
  }
  .ms-logo-obi{
    position: relative;
    height: 50px;
    padding: 5px 8px 5px 36px;
    background: rgb(var(--v-theme-topSecondaryBtn));
    font-size: 20px;
    color: rgb(var(--v-theme-topSecondaryBtnText));
    margin-left: -33px;
    /* line-height: 1.3; */
    top: 23px;
    z-index: -1;
  }
  .ms-logo-obi-tr {
    position: absolute;
    content: '';
    left: 378px;
    top: 0px;
    width: 0;
    height: 0;
    border: none;
    border-left: solid 40px rgb(var(--v-theme-topSecondaryBtn));
    border-bottom: solid 50px transparent;
    z-index: -1;
  }

  .sp-logo-position{
    position:absolute;
    left: 8px;
    top: 8px;
  }
  .sp-logo-obi{
    position: relative;
    height: 29px;
    padding: 3px 8px 5px 36px;
    background: rgb(var(--v-theme-topSecondaryBtn));
    font-size: 20px;
    color: rgb(var(--v-theme-topSecondaryBtnText));
    margin-left: -33px;
    top: 14px;
    line-height: 1;
    z-index: -1;
  }
  .sp-logo-obi-tr {
    position: absolute;
    content: '';
    left: 248px;
    top: 0px;
    width: 0;
    height: 0;
    border: none;
    border-left: solid 20px rgb(var(--v-theme-topSecondaryBtn));
    border-bottom: solid 29px transparent;
    z-index: -1;
  }
  @media screen and (max-width:342px) {
    .sp-logo-obi{
      width: 100vw
    }
    .sp-logo-obi:before{
      display:none;
    }
  }
  .link-sp-position{
    position: relative;
    top: -24px;
    left: 50%;
    transform: translateX(-50%);
  }
  .colum-item{
    flex-direction: column;
  }

  img[lazy=loaded] {
  animation-duration: 0.5s;
  animation-fill-mode: both;
  animation-name: scrollIn;
  }

  @keyframes scrollIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  /*重要なお知らせ*/
  @media screen and (min-width:600px){
    .important-notice{
      position: relative;
      width:90%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
    }
    .important-notice-title{
      color: #fff;
      font-weight: bold;
      display:block;
      background:#E53935;
      margin: 0 auto;
      position: relative;
      padding:8px;
    }
    .important-notice-text{
      position: relative;
      width:75%;
      height:100%;
      display:block;
      background:#fff;
      border: 3px solid #E53935;
      padding: 8px
    }
    .important-notice-title p{
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform : translate(-50%,-50%);
      transform : translate(-50%,-50%);
      text-align: center;
      width:100%;
    }
    .important-notice-text p {
      color:blue;
      position: absolute;
      top: 50%;
      -webkit-transform : translateY(-50%);
      transform : translateY(-50%);
      font-size:14px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-decoration: underline;
    }
    .important-notice-title-inner{
      position: absolute;
      top: 0;
      margin: auto;
      bottom: 0;
      display: table;
      left: 0;
      right: 0;
    }
  }
  @media screen and (max-width:600px){
    .important-notice{
      position: relative;
      max-width:505px;
      padding:0 16px;
      top:-75px;
    }
    .important-notice-title{
      height:27px;
      color: #fff;
      font-weight: bold;
      display:block;
      background:#E53935;
      margin: 0 auto;
    }
    .important-notice-text{
      display:block;
      background:#fff;
      border: 3px solid #E53935;
      padding: 8px;
      padding-top: 20px;
      display: flex;
      align-items: center;
    }
    .important-notice-title p{
      text-align: center;
      width:100%;
      margin-bottom: 0 !important;
      padding-top: 2px;
    }
    .important-notice-text p {
      color:blue;
      text-decoration: underline;
    }
    .important-notice-title-inner{
      text-align: center;
    }
  }
</style>
